import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

type UseWeeks = {
  week1: string;
  week2: string;
  week3: string;
  week4: string;
  week5: string;
};

type Props = {
  value: UseWeeks;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'UseWeeksContent',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: UseWeeks;
};



const valid = { color: "success" };
const invalid = { color: "grey" };

const validColor = (value: string) => {
  if (value === "1") {
    return valid;
  } else {
    return invalid;
  }
};

const items = computed(() => [
  { text: "1週", valid: validColor(props.value.week1) },
  { text: "2週", valid: validColor(props.value.week2) },
  { text: "3週", valid: validColor(props.value.week3) },
  { text: "4週", valid: validColor(props.value.week4) },
  { text: "5週", valid: validColor(props.value.week5) }
]);

return { __sfc: true,props, valid, invalid, validColor, items }
}

})